import React from 'react';
import { Spin, Tag } from 'antd';
import PropTypes from 'prop-types';
import roundCheck from '../../../../assets/img/round-check_circle-24px.svg';
import './InStackDemandOtherSelector.css';
import InStackDemandOtherSelectorModal from './InStackDemandOtherSelectorModal';
import { connect } from 'react-redux';
import { isNil } from 'lodash';

const SkillItem = ({ skill }) => {
  return (
    <div className={`InStackDemandItemSkillItem ${skill.checked ? 'checked' : ''}`} onClick={e => skill.set({ checked: !skill.checked })}>
      <img
        src={roundCheck}
        style={{
          width: 18,
          height: 18,
          background: `transparent url(${roundCheck}) 0% 0% no-repeat padding-box !important`,
          opacity: 1
        }}
        alt="check"
      />
      <span>{ skill.skill_name }</span>
    </div>
  );
};

SkillItem.propTypes = {
  skill: PropTypes.object
};

class InStackDemandOtherSelector extends React.Component {
  state = {
    loading: false,
    item: {
      checked: false,
      stack_demand_name: 'Other (please specify)',
      no_of_jobs: 0,
      popupVisible: false,
      nbr_require: true,
      skills: [
        {
          skill_id: 0,
          skill_name: 'Skill 0',
          require: true,
          checked: true
        },
        {
          skill_id: 1,
          skill_name: 'Skill 1',
          require: false,
          checked: true
        },
        {
          skill_id: 2,
          skill_name: 'Skill 2',
          require: true,
          checked: false
        }
      ]
    },
    activeItem: null
  };

  onChange = (e) => {
    this.setState({
      ...this.state,
      activeItem: {
        close: (e) => {
          this.setState({
            ...this.state,
            activeItem: null
          });
        }
      }
    });
  }

  checkIfChecked () {
    const item = this.state.item;
    item.checked = !isNil(this.props.user_demand_stack_skills.otherStackDemandId);
    this.setState({
      item
    });
  }

  componentDidMount () {
    this.checkIfChecked();
  }

  componentDidUpdate (prevProps) {
    if (prevProps.skillEditor.user_other_skills.length !== this.props.skillEditor.user_other_skills.length) {
      this.checkIfChecked();
    }
  }

  onClose = (e, args) => {
    if (typeof this.props.onClose === 'function') this.props.onClose(e, args);
    this.checkIfChecked();
  }

  render () {
    return (
      <div className="InStackDemandOtherSelector">
        <Spin spinning={this.state.loading}>
          <Tag.CheckableTag className="InStackDemandItem" checked={this.state.item.checked} onChange={this.onChange} onClick={e => e.stopPropagation()}>
            <span>{ this.state.item.stack_demand_name }</span>
            {this.state.item.no_of_jobs ? <span className="njobs">{ this.state.item.no_of_jobs > 1 ? this.state.item.no_of_jobs + ' jobs' : this.state.item.no_of_jobs + ' job' }</span> : null}
            {this.state.item.popupVisible
              ? (
                <div className="InStackDemandItemPopupList" onClick={e => e.stopPropagation()}>
                  <div className="InStackDemandItemPopupList-title">
                    <span>SELECT ADDITIONAL SKILLS</span>
                    <span>Require at least { this.state.item.nbr_require > 0 ? this.state.item.nbr_require : '' }</span>
                  </div>
                  { this.state.item.skills.filter(skill => !skill.require).map(skill =>
                    <SkillItem key={skill.skill_id} skill={skill} />
                  ) }
                </div>
              )
              : null}
          </Tag.CheckableTag>
        </Spin>
        <InStackDemandOtherSelectorModal activeItem={ this.state.activeItem } onClose={ this.onClose.bind(this) }/>
      </div>
    );
  }
}

InStackDemandOtherSelector.propTypes = {
  onClose: PropTypes.any,
  skillEditor: PropTypes.object,
  user_demand_stack_skills: PropTypes.object
};

const mapStateToProps = appState => ({
  skillEditor: appState.skillEditor,
  user_demand_stack_skills: appState.user_demand_stack_skills
});

const mapDispatchToProps = (dispatch) => ({ dispatch });

export default connect(mapStateToProps, mapDispatchToProps)(InStackDemandOtherSelector);
